export const TransportService = [
    {
        id: 1,
        name: 'International Air'
    },
    {
        id: 2,
        name: 'Road'
    },
    {
        id: 3,
        name: 'Road&Sea'
    },
    {
        id: 4,
        name: 'Sea'
    }
];
